import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
// import { LoginPage } from './pages/auth';
import { LoginPage, RegisterPage, ForgetPasswordPage, ResetPasswordPage, VerifyAgent } from './pages/auth';
import ErrorMessage from './components/ErrorMessage';
import Page from './components/Page';
import CheckMail from './pages/checkMail';
import { load_product } from './actions/product.actions';
import Payment from './pages/payment';
import Phones from './pages/phones';
import SecretPhones from './pages/secretphones';
import ChatPage from './pages/chat';
import Analytic from './pages/analytics';
import AgentPage from './pages/agent';
import Settings from './pages/settings';
import Admin from './pages/admin/router';
import Developers from './pages/developers';
import Contact from './pages/contact';
import ButtonWidget from './pages/button';
import Survey from './pages/survey';
import Instagram from './pages/instagram';
import getStarted from './pages/get-started';
import Trial from './components/trial';
import PhoneDetail from './pages/phonedetail';
import PhoneProxy from './pages/phoneproxy';
import Integrations from './pages/integrations';
import Tools from './pages/tools';
import Base64Encoder from './pages/tools/base64encoder';
import VCardMaker from './pages/tools/vcardmaker';
import WhatsappNumberChecker from './pages/tools/numberChecker';
import WhatsappProfilePicture from './pages/tools/whatsappPicture';
import QRCodeGenerator from './pages/tools/qrCodeGenerator';
import TextFormatter from './pages/tools/textFormatter';
import Googlecontacts from './pages/integrations/googlecontacts';
import Googlesheets from './pages/integrations/googlesheets';
import Dialogflow from './pages/integrations/dialogflow';
import PartnerSubs from './pages/partner_subscription';
import PaddlePaymentPage from './pages/paymentPage';
import PaddleNewPaymentPage from './pages/paddleNewPayment';

function NoMatch() {
	return <ErrorMessage title="We are sorry, Page not found!." list={['Please check that the connection is correct.']} code="404" />;
}

const LoadProduct = connect()(function (props) {
	const { dispatch } = props;
	React.useEffect(() => {
		dispatch(load_product('maytapi'));
	}, [dispatch]);
	return <Page.Loader />;
});

const LayoutRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={(matchProps) => (
			<>
				<Component {...matchProps} />{' '}
			</>
		)}
	/>
);

class App extends React.PureComponent {
	render() {
		if (this.props.access.loading === 'profile' || this.props.product.loading) return <Page.Loader />;
		const user = this.props.access.user;
		let isPartner = this.props.product.maytapi && this.props.product.maytapi.settings && this.props.product.maytapi.settings.partner;
		return (
			<Switch>
				{/* Public routes - No authentication required */}
				<Route path="/login" component={LoginPage} />
				<Route path="/register" component={RegisterPage} />
				<Route exact path="/forgot" component={ForgetPasswordPage} />
				<Route path="/forgot/checkyourmail" component={CheckMail} />
				<Route path="/verify/resetPassword/:token" component={ResetPasswordPage} />
				<Route path="/verify/agent/:token" component={VerifyAgent} />

				{/* Standalone Payment Page - No authentication required */}
				<Route path="/payment/:productId" component={PaddlePaymentPage} />
				<Route path="/payment_onetime/:productId" component={PaddleNewPaymentPage} />

				{/* Trial route */}
				{this.props && this.props.product && this.props.product.maytapi && this.props.product.maytapi.trial === null ? (
					<LayoutRoute component={Trial} />
				) : null}

				{/* Redirect to login if not authenticated */}
				{(!user || !user.isAuthenticated) && <Redirect to={{ pathname: '/login', state: { from: this.props.location } }} />}
				{!this.props.product.maytapi && <Route component={LoadProduct} />}

				{/* Protected routes - Authentication required */}
				<Route path="/" exact component={Phones} />
				<Route path="/settings/payment" exact component={Payment} />
				<Route path="/subscription" component={isPartner ? PartnerSubs : Payment} />
				<Route path="/subscription_partner" component={PartnerSubs} />
				<Route path="/chat" component={ChatPage} />
				<Route path="/developers" component={Developers} />
				<Route path="/secret-phones" component={SecretPhones} />
				<Route path="/phones" component={Phones} />
				<Route path="/agents" component={AgentPage} />
				<Route path="/analytic" component={Analytic} />
				<Route path="/contact" component={Contact} />
				<Route path="/documentation" component={() => <Redirect to="/developers/documentation" />} />
				<Route path="/yta" component={Admin} />
				<Route path="/settings" component={Settings} />
				<Route path="/instagram" component={Instagram} />
				<Route path="/button" component={ButtonWidget} />
				<Route path="/survey" component={Survey} />
				<Route path="/get-started" component={getStarted} />
				<Route path="/phone-detail/:phone" component={PhoneDetail} />
				<Route path="/phone-proxy/:phone" component={PhoneProxy} />
				<Route path="/integrations" component={Integrations} />
				<Route path="/integrations/contacts" component={Googlecontacts} />
				<Route path="/integrations/sheets" component={Googlesheets} />
				<Route path="/integrations/dialogflow" component={Dialogflow}></Route>
				<Route path="/tools" component={Tools} />
				<Route path="/tools/base64encoder" component={Base64Encoder} />
				<Route path="/tools/vcardmaker" component={VCardMaker} />
				<Route path="/tools/whatsapp-number-checker" component={WhatsappNumberChecker} />
				<Route path="/tools/qr-code-generator" component={QRCodeGenerator} />
				<Route path="/tools/whatsapp-text-formatter" exact component={TextFormatter} />
				<Route path="/tools/get-whatsapp-profile-picture" exact component={WhatsappProfilePicture} />
				<Route component={NoMatch} />
			</Switch>
		);
	}
}

const stateToProps = (state) => ({ access: state.access, product: state.product, location: state.router.location });

export default connect(stateToProps)(App);
